import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const UsersRedux = createActions({
  postUserPicutreRequest: ['id', 'data'],
  postUserPicutreSuccess: [''],
  postUserPicutreError: ['error'],
}, {
  prefix: 'USERS_',
  defaultActions: {
    get: true,
  },
})

const { Types, Creators } = UsersRedux
export const UsersTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  picture: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})


const postUserPicutreRequest = state => state.merge({ picture: { fetching: true } }, d)
const postUserPicutreSuccess = state => (
  state.merge({ picture: { fetching: false } }, d)
)
const postUserPicutreError = (state, { error }) => (
  state.merge({ picture: { fetching: false, error } }, d)
)


export const reducer = createReducer(INITIAL_STATE, {
  [Types.postUserPicutreRequest]: postUserPicutreRequest,
  [Types.postUserPicutreSuccess]: postUserPicutreSuccess,
  [Types.postUserPicutreError]: postUserPicutreError,
}, {
  defaultActions: {
    get: true,
  },
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/UsersRedux.js